import { render, staticRenderFns } from "./Coollapse.vue?vue&type=template&id=95b72160"
import script from "./Coollapse.vue?vue&type=script&lang=js"
export * from "./Coollapse.vue?vue&type=script&lang=js"
import style0 from "./Coollapse.vue?vue&type=style&index=0&id=95b72160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports